export default __webpack_public_path__ + "static/media/Calibre-Light.c7ac1cf0.ttf";